import React from 'react';
import parse from 'html-react-parser';
import Form from '../Form';
import { TInput } from '../../utils/types';

export interface ContentProps {
  objdata: {[name: string]: string}
  inputData: TInput
  samtykkeLabel?: string
  showForm: boolean
  velkomstEpiserverId: string
  setInputData: (inputData: TInput) => void
  setFormSubmitted: (submitted: boolean) => void
  handleContentSkip: React.MouseEventHandler<HTMLButtonElement>
  setShowSalaryReceipt: (showSalaryReceipt: boolean) => void
  setShowModal: (showModal: boolean) => void
}

const Content = ({
	objdata,
	inputData,
	samtykkeLabel,
	showForm,
	velkomstEpiserverId,
	setInputData,
	setFormSubmitted,
	setShowSalaryReceipt,
	setShowModal,
	handleContentSkip
}: ContentProps) => {
	if (showForm) {
		return (
			<div className="content">
				<div className="content-richtext">
					<h1>{ objdata['IntroTitle'] }</h1>
					{ objdata['IntroText'] && parse(objdata['IntroText']) }
				</div>
				<Form
					objdata={ objdata }
					introButtonText={ objdata['IntroButtonText'] }
					inputData={ inputData }
					showEmail={ true }
					showPhn={ true }
					showSalary={ false }
					showDataPolicy={ true }
					showConsent={ false }
					persondataLabel={ objdata['PersondataLabel'] }
					samtykkeLabel={ samtykkeLabel }
					velkomstEpiserverId={ velkomstEpiserverId }
					baseInteraktionDialogId={ objdata['BaseInteraktionDialogId'] }
					setInputData={ setInputData }
					setFormSubmitted={ setFormSubmitted }
					setShowSalaryReceipt={ setShowSalaryReceipt }
					setShowModal={ setShowModal }
					handleContentSkip={ handleContentSkip }
					skipBtnText={ objdata['SkipButtonText'] }
				/>
			</div>
		);
	}

	return null;
};

export default Content;
